<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent value="" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ modalTitle }} Additional Info</span>
          <v-spacer></v-spacer>
          <v-btn text icon color="grey" @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <confirm-delete-in-modal
              v-if="showConfirmDelete"
              @confirmed="onConfirmDelete"
            ></confirm-delete-in-modal>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12" sm="3">
                  <v-select
                    v-model="typeSelected"
                    class="py-1"
                    dense
                    :items="['Source', 'URL']"
                    label="Type"
                    required
                    :rules="[v => !!v || 'Type is required']"
                    v-on:change="onTypeChange"
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="9" v-if="showURLField">
                  <v-text-field
                    label="URL"
                    v-model="urlValue"
                    class="py-1"
                    dense
                    required
                    :rules="[v => !!v || 'URL is required']"
                    persistent-hint
                    hint="e.g. http://www.mywebsite.com"
                    v-on:keyup.enter="onSave"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="5" v-if="showSourceField">
                  <v-autocomplete
                    hint="How did you hear about us?"
                    required
                    :rules="[v => !!v || 'Source is required']"
                    v-model="sourceSelected"
                    class="py-1"
                    dense
                    :items="leadSources"
                    item-text="name"
                    item-value="id"
                    label="Source"
                    persistent-hint
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  v-if="
                    showSourceField && sourceSelected && sourceSelected == -1
                  "
                >
                  <v-text-field
                    label="Other"
                    v-model="otherValue"
                    class="py-1"
                    dense
                    hint="How did you hear about us?"
                    required
                    :rules="[
                      v => !!v || 'Details are required when you select other'
                    ]"
                    v-on:keyup.enter="onSave"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="showDelete" color="blue darken-1" text @click="onDelete"
            >Delete</v-btn
          >
          <v-btn color="primary tile" @click="onSave"
            >&nbsp;&nbsp;&nbsp;Save&nbsp;&nbsp;&nbsp;</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
const ConfirmDeleteInModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-ConfirmDeleteInModal" */ `./ConfirmDeleteInModal.vue`
  );

export default {
  name: "OtherInfoFormModal",
  props: {
    otherInfoId: Number,
    otherInfoCustomerId: Number
  },
  components: {
    ConfirmDeleteInModal
  },
  data: () => ({
    dialog: true,
    modalTitle: "Add",
    valid: true,
    showURLField: false,
    showSourceField: false,
    showConfirmDelete: false,
    sourceSelected: null,
    typeSelected: null,
    urlValue: null,
    otherValue: null
  }),
  computed: {
    isAddNew() {
      return this.otherInfoId == -1;
    },
    showDelete() {
      return !this.isAddNew && !this.showConfirmDelete;
    },
    leadSources() {
      let leadSources = this.$store.getters[
        "entities/listItems/query"
      ]().get();
      if (leadSources && leadSources.length > 0) {
        leadSources.push({
          id: -1,
          name: "Other"
        });
        return leadSources;
      } else {
        return [];
      }
    },
    currentOtherInfo() {
      let otherInfo = this.$store.getters["entities/otherInfos/find"](
        this.otherInfoId
      );
      return otherInfo;
    },
    user() {
      return this.$store.getters["entities/users/find"](
        this.$store.getters["entities/settings/query"]().first().userId
      );
    }
  },
  created() {
    if (this.otherInfoId > 0 && this.currentOtherInfo) {
      this.modalTitle = "Update";
      this.typeSelected = this.currentOtherInfo.label;
      this.onTypeChange(this.typeSelected);
      this.urlValue = this.currentOtherInfo.detail;
      this.sourceSelected = { id: this.currentOtherInfo.listItemId };
      if (
        this.typeSelected == "Source" &&
        !this.currentOtherInfo.listItemId
      ) {
        this.sourceSelected = -1;
      }
      this.otherValue = this.currentOtherInfo.detail;
    }
  },
  methods: {
    clearInputs() {
      this.urlValue = null;
      this.otherValue = null;
    },
    onTypeChange(type) {
      if (type == "URL") {
        this.showURLField = true;
        this.showSourceField = false;
      } else if (type == "Source") {
        this.showURLField = false;
        this.showSourceField = true;
      }
      this.clearInputs();
    },
    onClose() {
      this.$root.$children[0].showCustomerEditorModals = false;
    },
    onSave() {
      if (this.$refs.form.validate()) {
        let detail = null;
        if (this.typeSelected == "URL") {
          detail = this.urlValue;
        } else if (
          this.typeSelected == "Source" &&
          this.sourceSelected &&
          parseInt(this.sourceSelected) == -1
        ) {
          detail = this.otherValue;
        }
        if (this.isAddNew) {
          const tempId = this.$uuidv4();
          this.$store.dispatch("entities/otherInfos/createOtherInfo", {
            id: tempId,
            tempId: tempId,
            isDirty: true,
            accountId: this.user.accountId,
            customerId:
              this.otherInfoCustomerId ||
              parseInt(this.user.currentCustomerId),
            label: this.typeSelected,
            listItemId:
              this.sourceSelected && this.sourceSelected > 0
                ? this.sourceSelected
                : null,
            detail: detail
          });
        } else if (this.otherInfoId > 0) {
          this.$store.dispatch("entities/otherInfos/updateOtherInfo", {
            accountId: this.user.accountId,
            customerId:
              this.otherInfoCustomerId ||
              parseInt(this.user.currentCustomerId),
            id: this.otherInfoId,
            isDirty: true,
            label: this.typeSelected,
            listItemId:
              this.sourceSelected && this.sourceSelected > 0
                ? this.sourceSelected
                : null,
            detail: detail
          });
        }
        this.onClose();
      }
    },
    onDelete() {
      this.showConfirmDelete = true;
    },
    onConfirmDelete() {
      this.$store.dispatch("entities/otherInfos/deleteOtherInfo", {
        accountId: this.user.accountId,
        id: this.otherInfoId,
        isDirty: true
      });
      this.onClose();
    }
  }
};
</script>
<style scoped lang="stylus"></style>
